/**
 * Licensed Materials - Property of IBM
 *
 * IBM Cognos Products: BI Glass
 *
 * (C) Copyright IBM Corp. 2017
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define({
		"rtl": "«头'ทั้ดูΣ＿Right-to-left＿Э İı｜尾»",
		"timeZoneID": "«头'ทั้ดูΣ＿Time zone＿Э İı｜尾»",
		"skin": "«头'ทั้ดูΣ＿Style＿Э İı｜尾»",
		"metricsFileImportTask": "«头'ทั้ดูΣ＿New Import from Files＿Э İı｜尾»",
		"displayMode": "«头'ทั้ดูΣ＿Default view＿Э İı｜尾»",
		"credentialRenewed": "«头'ทั้ดูΣ＿Ｙｏｕｒ credentials were renewed with your current user ID and password.＿Э İı｜尾»",
		"productLocale": "«头'ทั้ดูΣ＿Product language＿Э İı｜尾»",
		"credentialChange": "«头'ทั้ดูΣ＿Renew＿Э İı｜尾»",
		"log_level_Debug": "«头'ทั้ดูΣ＿Debug＿Э İı｜尾»",
		"unsavedViewMsg2": "«头'ทั้ดูΣ＿Ｙｏｕr changes will be lost if you don't save them first.＿Э İı｜尾»",
		"confirmNewPassword": "«头'ทั้ดูΣ＿Confirm new password＿Э İı｜尾»",
		"supportPortalErrorMessage": "[«头'ทั้ดูΣ＿Ｔｒｙ ａgain.  If the problem persists, contact your administrator.＿Э İı｜尾»]",
		"legalText": "[«头'ทั้ดูΣ＿Ｌｉｃｅｎｓｅｄ Ｍａｔｅｒｉａｌｓ - Ｐｒｏｐｅｒｔｙ ｏｆ ＩＢＭ Ｃｏｒｐ. �� Ｃｏｐｙｒｉｇｈｔ ＩＢＭ Ｃｏｒｐｏｒａｔｉｏｎ ａｎｄ ｏｔｈｅｒ(ｓ) 2005, [%{year}]. ＩＢＭ, ｔｈｅ ＩＢＭ ｌｏｇｏ, ｉｂｍ.ｃｏｍ ａｎｄ Ｃｏｇｎｏｓ ａｒｅ ｔｒａｄｅｍａｒｋｓ ｏｒ ｒｅｇｉｓｔｅｒｅｄ ｔｒａｄｅｍａｒｋｓ ｏｆ Ｉｎｔｅｒｎａｔｉｏｎａｌ Ｂｕｓｉｎｅｓｓ Ｍａｃｈｉｎｅｓ Ｃｏｒｐ., ｒｅｇｉｓｔｅｒｅｄ ｉｎ ｍａｎｙ ｊｕｒｉｓｄｉｃｔｉｏｎｓ ｗｏｒｌｄｗｉｄｅ. Ａ ｃurrent list of IBM trademarks is available on the Web at www.ibm.com/legal/copytrade.shtml. This Program is licensed under the terms of the license agreement accompanying the Program. This license agreement may be either located in a Program directory folder or library identified as \"License\" or \"Non_IBM_License\" if applicable, or provided as a printed license agreement. Please read the agreement carefully before using the Program. By using the Program you agree to these terms.＿Э İı｜尾»]",
		"groupsAndRoles": "«头'ทั้ดูΣ＿Groups and roles＿Э İı｜尾»",
		"metricsMaintenanceTask": "«头'ทั้ดูΣ＿New Maintenance＿Э İı｜尾»",
		"email": "«头'ทั้ดูΣ＿Email＿Э İı｜尾»",
		"contextual": "«头'ทั้ดูΣ＿Contextual＿Э İı｜尾»",
		"resetHome": "«头'ทั้ดูΣ＿Reset to default＿Э İı｜尾»",
		"ltr": "«头'ทั้ดูΣ＿Left-to-right＿Э İı｜尾»",
		"credentials": "«头'ทั้ดูΣ＿Credentials＿Э İı｜尾»",
		"logging_congfig_title": "«头'ทั้ดูΣ＿Logging＿Э İı｜尾»",
		"changePasswordTitle": "«头'ทั้ดูΣ＿Change my password＿Э İı｜尾»",
		"format": "«头'ทั้ดูΣ＿Report format＿Э İı｜尾»",
		"showUnread": "«头'ทั้ดูΣ＿Show unread＿Э İı｜尾»",
		"docsErrorMessage": "[«头'ทั้ดูΣ＿Ｔｒｙ ａgain.  If the problem persists, contact your administrator.＿Э İı｜尾»]",
		"homeSetError": "[«头'ทั้ดูΣ＿Ａｎ ｅｒｒｏｒ occurred setting the default home page, try closing and reopening this view.＿Э İı｜尾»]",
		"passwordChange": "«头'ทั้ดูΣ＿Change your password＿Э İı｜尾»",
		"pdfRestricted": "«头'ทั้ดูΣ＿PDF (Restricted)＿Э İı｜尾»",
		"drillThrough": "«头'ทั้ดูΣ＿Drill-Through definitions＿Э İı｜尾»",
		"homeSet": "«头'ทั้ดูΣ＿Your home was set successfully＿Э İı｜尾»",
		"regionalOptions": "«头'ทั้ดูΣ＿Options for your region＿Э İı｜尾»",
		"myPreferences": "«头'ทั้ดูΣ＿My preferences＿Э İı｜尾»",
		"defaultHome": "«头'ทั้ดูΣ＿Default＿Э İı｜尾»",
		"version": "«头'ทั้ดูΣ＿Version＿Э İı｜尾»",
		"controller": "«头'ทั้ดูΣ＿Controller＿Э İı｜尾»",
		"manage": "«头'ทั้ดูΣ＿Manage＿Э İı｜尾»",
		"biDirectionalFeaturesEnabled": "«头'ทั้ดูΣ＿Bidirectional language support＿Э İı｜尾»",
		"newFeaturesErrorTitle": "«头'ทั้ดูΣ＿Ｔhe link to New Features did not work＿Э İı｜尾»",
		"passwordMatch": "«头'ทั้ดูΣ＿Password match＿Э İı｜尾»",
		"dashboardConsole": "«头'ทั้ดูΣ＿Workspace＿Э İı｜尾»",
		"legacyAppsSlideoutLabel": "«头'ทั้ดูΣ＿Available Legacy Applications＿Э İı｜尾»",
		"logging_config_description": "«头'ทั้ดูΣ＿Ｌｏｇｇｉｎｇ ｉs used for troubleshooting. Consult your administrator for guidance on settings.＿Э İı｜尾»",
		"signInButtonText": "«头'ทั้ดูΣ＿Sign in＿Э İı｜尾»",
		"dataSourceCredentials": "«头'ทั้ดูΣ＿Data server credentials＿Э İı｜尾»",
		"spreadsheetMLRestricted": "«头'ทั้ดูΣ＿Excel (Restricted)＿Э İı｜尾»",
		"xlsxDataRestricted": "«头'ทั้ดูΣ＿Excel Data (Restricted)＿Э İı｜尾»",
		"advanced": "«头'ทั้ดูΣ＿Advanced＿Э İı｜尾»",
		"ok": "«头'ทั้ดูΣ＿OK＿Э İı｜尾»",
		"showHints": "«头'ทั้ดูΣ＿Show hints＿Э İı｜尾»",
		"general": "«头'ทั้ดูΣ＿General＿Э İı｜尾»",
		"xlsxData": "«头'ทั้ดูΣ＿Excel Data＿Э İı｜尾»",
		"personal": "«头'ทั้ดูΣ＿Personal＿Э İı｜尾»",
		"newPassword": "«头'ทั้ดูΣ＿New password＿Э İı｜尾»",
		"confirmPassword": "«头'ทั้ดูΣ＿Confirm password＿Э İı｜尾»",
		"hideAll": "«头'ทั้ดูΣ＿Hide all＿Э İı｜尾»",
		"metricStudio": "«头'ทั้ดูΣ＿Studio＿Э İı｜尾»",
		"supportPortalErrorTitle": "«头'ทั้ดูΣ＿Ｔｈe link to Support Portal didn't work＿Э İı｜尾»",
		"log_level_Warn": "«头'ทั้ดูΣ＿Warning＿Э İı｜尾»",
		"myCapabilities": "«头'ทั้ดูΣ＿My capabilities＿Э İı｜尾»",
		"homePage": "«头'ทั้ดูΣ＿Home page＿Э İı｜尾»",
		"helpErrorMessage": "[«头'ทั้ดูΣ＿Ｔｒｙ ａgain.  If the problem persists, contact your administrator.＿Э İı｜尾»]",
		"portal": "«头'ทั้ดูΣ＿Portal＿Э İı｜尾»",
		"metricsPackage": "«头'ทั้ดูΣ＿New Package＿Э İı｜尾»",
		"myCredentials": "«头'ทั้ดูΣ＿My credentials＿Э İı｜尾»",
		"credentialCreate": "«头'ทั้ดูΣ＿Create＿Э İı｜尾»",
		"eventStudio": "«头'ทั้ดูΣ＿Event Studio＿Э İı｜尾»",
		"updatePWUnknownError": "«头'ทั้ดูΣ＿Unable to update password＿Э İı｜尾»",
		"csv": "«头'ทั้ดูΣ＿CSV＿Э İı｜尾»",
		"showHiddenObjects": "«头'ทั้ดูΣ＿Show hidden entries＿Э İı｜尾»",
		"docsErrorTitle": "«头'ทั้ดูΣ＿Ｔhe link to Documentation didn't work＿Э İı｜尾»",
		"log_level_Error": "«头'ทั้ดูΣ＿Error＿Э İı｜尾»",
		"wrongPassword": "«头'ทั้ดูΣ＿Unable to authenticate＿Э İı｜尾»",
		"productName": "[«头'ทั้ดูΣ＿IBM Cognos Analytics [%{version}]＿Э İı｜尾»]",
		"log_level_Info": "«头'ทั้ดูΣ＿Information＿Э İı｜尾»",
		"helpErrorTitle": "«头'ทั้ดูΣ＿The link to Help didn't work＿Э İı｜尾»",
		"contentLocale": "«头'ทั้ดูΣ＿Content language＿Э İı｜尾»",
		"pdf": "«头'ทั้ดูΣ＿PDF＿Э İı｜尾»",
		"oldPassword": "«头'ทั้ดูΣ＿Old password＿Э İı｜尾»",
		"spreadsheetML": "«头'ทั้ดูΣ＿Excel＿Э İı｜尾»",
		"accessibilityFeatures": "«头'ทั้ดูΣ＿Turn on accessibility features＿Э İı｜尾»",
		"manageLogging": "«头'ทั้ดูΣ＿Logging＿Э İı｜尾»",
		"loggingConfigurationSlideoutA11yLabel": "«头'ทั้ดูΣ＿Logging Configuration＿Э İı｜尾»",
		"communityErrorTitle": "«头'ทั้ดูΣ＿Ｔhe link to Community didn't work＿Э İı｜尾»",
		"companionApps": "«头'ทั้ดูΣ＿Companion applications＿Э İı｜尾»",
		"metricsExportTask": "«头'ทั้ดูΣ＿New Export＿Э İı｜尾»",
		"csvRestricted": "«头'ทั้ดูΣ＿CSV (Restricted)＿Э İı｜尾»",
		"newFeaturesErrorMessage": "[«头'ทั้ดูΣ＿Ｔｒｙ ａgain.  If the problem persists, contact your administrator.＿Э İı｜尾»]",
		"contributor": "«头'ทั้ดูΣ＿Contributor＿Э İı｜尾»",
		"showAll": "«头'ทั้ดูΣ＿Show all＿Э İı｜尾»",
		"logging_active": "«头'ทั้ดูΣ＿Logging is on:＿Э İı｜尾»",
		"baseTextDirection": "«头'ทั้ดูΣ＿Base direction for text＿Э İı｜尾»",
		"html": "«头'ทั้ดูΣ＿HTML＿Э İı｜尾»",
		"queryStudio": "«头'ทั้ดูΣ＿Query Studio＿Э İı｜尾»",
		"metricsManager": "«头'ทั้ดูΣ＿Metrics Manager＿Э İı｜尾»",
		"password": "«头'ทั้ดูΣ＿Password＿Э İı｜尾»",
		"credentialCreateSuccess": "«头'ทั้ดูΣ＿Ｙｏu have successfully created your credentials＿Э İı｜尾»",
		"settings": "«头'ทั้ดูΣ＿Settings＿Э İı｜尾»",
		"restrictedFormatSelected": "[«头'ทั้ดูΣ＿Ｙｏｕ ｄｏ ｎｏｔ ｈａｖｅ ｔｈｅ ｃａpability to run reports in this format, but you can access reports that are saved in this format.＿Э İı｜尾»]",
		"powerplayStudio": "«头'ทั้ดูΣ＿PowerPlay Studio＿Э İı｜尾»",
		"viewDetails": "«头'ทั้ดูΣ＿View details＿Э İı｜尾»",
		"showPassword": "«头'ทั้ดูΣ＿Show password＿Э İı｜尾»",
		"myPreferencesSlideoutLabel": "«头'ทั้ดูΣ＿My Preferences＿Э İı｜尾»",
		"passWordChangeSuccess": "«头'ทั้ดูΣ＿Ｙｏu have successfully changed your password＿Э İı｜尾»",
		"logging_level": "«头'ทั้ดูΣ＿Logging level:＿Э İı｜尾»",
		"analysisStudio": "«头'ทั้ดูΣ＿Analysis Studio＿Э İı｜尾»",
		"communityErrorMessage": "[«头'ทั้ดูΣ＿Ｔｒｙ ａgain.  If the problem persists, contact your administrator.＿Э İı｜尾»]",
		"cancel": "«头'ทั้ดูΣ＿Cancel＿Э İı｜尾»",
		"shareSetError": "«头'ทั้ดูΣ＿Ｔｈｉs action cannot be performed before closing and reopening this view.＿Э İı｜尾»",
		"passwordNotMatch": "[«头'ทั้ดูΣ＿Oops, password does not match＿Э İı｜尾»]",
		"xml": "«头'ทั้ดูΣ＿XML＿Э İı｜尾»",
		"xmlRestricted": "«头'ทั้ดูΣ＿XML (Restricted)＿Э İı｜尾»"
});